import 'tempusdominus-bootstrap-4';

export class CalculatorPage {
	constructor() {
		$(() => {
			($('#dose4') as any).datetimepicker({ icons: { time: "fas fa-clock", date: "fas fa-calendar", up: "fas fa-arrow-up", down: "fas fa-arrow-down" }, sideBySide: true });
			($('#dose3') as any).datetimepicker({ icons: { time: "fas fa-clock", date: "fas fa-calendar", up: "fas fa-arrow-up", down: "fas fa-arrow-down" }, sideBySide: true });
			($('#dose2') as any).datetimepicker({ icons: { time: "fas fa-clock", date: "fas fa-calendar", up: "fas fa-arrow-up", down: "fas fa-arrow-down" }, sideBySide: true });
			($('#dose1') as any).datetimepicker({ icons: { time: "fas fa-clock", date: "fas fa-calendar", up: "fas fa-arrow-up", down: "fas fa-arrow-down" }, sideBySide: true });
			($('#calculateButton') as any).click(() => {
				// make sure dose1, dose2, dose3, and dose4 are filled out
				if (($('#dose1Input') as any).val() === '' || ($('#dose2Input') as any).val() === '' || ($('#dose3Input') as any).val() === '' || ($('#dose4Input') as any).val() === '') {
					$('#taperBody').html("Please fill out all four doses before calculating the taper.");
					$('#taperDialog').modal('show');
					return;
				}
				// grab the date from dose4 and dose1
				const dose4 = new Date(($('#dose4Input') as any).val());
				const dose1 = new Date(($('#dose1Input') as any).val());
				// calculate the difference
				const diff = Math.abs(dose4.getTime() - dose1.getTime()) / 1000;
				if (diff > 86400) {
					$('#taperBody').html("The next planned dose will NOT be the fourth dose this baby receives in 24 hours. Please proceed with symptom-based dosing with the next planned dose (Dose 4).");
					$('#taperDialog').modal('show');
				}
				else {
					$('#taperBody').html("The administration of the 4th dose entered in this calculator requires a transition to a scheduled opioid taper.Please initiate your site’s scheduled opioid taper with administration of this 4th dose.");
					$('#taperDialog').modal('show');
				}
				
			});
		});
	}

}
